import { render, staticRenderFns } from "./PreChat.vue?vue&type=template&id=5ea1b5fb&scoped=true&"
import script from "./PreChat.vue?vue&type=script&lang=js&"
export * from "./PreChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea1b5fb",
  null
  
)

export default component.exports